import React from 'react';
import { colors } from '@insurancemenu/imenu-components-lib';
import { ErrorOutline } from '@insurancemenu/imenu-components-lib/dist/icons';
import { ICustomizableElement } from '@insurancemenu/imenu-components-lib/dist/types';
import { SUB_INCOMPLETE_PROFILE_TAG_TEST_ID } from '../../constants';
import { IncompleteProfileErrorTagStyled, IncompleteProfileInnerTagStyled } from './styles';

interface IncompleteProfileErrorTagProps extends ICustomizableElement {
  isAddedToBatchSelection: boolean;
  isEditable: boolean;
}

const IncompleteProfileErrorTag: React.FC<IncompleteProfileErrorTagProps> = ({
  isAddedToBatchSelection,
  isEditable,
  className,
}) => {
  return (
    <IncompleteProfileErrorTagStyled
      $isAddedToBatchSelection={isAddedToBatchSelection}
      $isEditable={isEditable}
      className={className}
      data-test-id={SUB_INCOMPLETE_PROFILE_TAG_TEST_ID}
    >
      <IncompleteProfileInnerTagStyled $isAddedToBatchSelection={isAddedToBatchSelection}>
        <ErrorOutline width="2rem" color={colors.red[600]} />
        <span>Update Employee Profile</span>
      </IncompleteProfileInnerTagStyled>
    </IncompleteProfileErrorTagStyled>
  );
};

export default IncompleteProfileErrorTag;
